// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants";

const maybeNullString = anyOf(nullOrUndefined, string);

const isCustomObjectImportStagingRecordStatus = enumOf(
  ...sharedConstants.CUSTOM_OBJECT_IMPORT.STAGING_RECORD_STATUSES
);

const isCustomObjectImportRecordType = enumOf(...sharedConstants.CUSTOM_OBJECT_IMPORT.RECORD_TYPES);

const isCustomObjectImportAction = enumOf(...sharedConstants.CUSTOM_OBJECT_IMPORT.ACTIONS);

const isCustomObjectsImportStagingRecordsResultItem = objectOf({
  id: string,
  source_import_id: string,
  source_chunk_id: string,
  status: isCustomObjectImportStagingRecordStatus,
  error_code: maybeNullString,
  error_message: maybeNullString,
  payload: objectOf({}),
  record_type: isCustomObjectImportRecordType,
  action: isCustomObjectImportAction,
  object_id: maybeNullString,
  created_at: string,
  updated_at: string,
});

export const isCustomObjectsImportStagingRecordsResult = objectOf({
  hits: number,
  results: arrayOf(isCustomObjectsImportStagingRecordsResultItem),
});
